/**
 * Ashtamsha D8 Table Color Configuration
 * Colors for different planet types in D8 table display
 */

export interface AshtamshaPlanetColors {
  /** Regular planets */
  regular: {
    color: string;
    backgroundColor: string;
    borderColor?: string;
  };
  /** Lagna */
  lagna: {
    color: string;
    backgroundColor: string;
    borderColor?: string;
  };
  /** Current Hora lord */
  hora: {
    color: string;
    backgroundColor: string;
    borderColor?: string;
  };
  /** Chandra (Moon) */
  chandra: {
    color: string;
    backgroundColor: string;
    borderColor?: string;
  };
  /** Retrograde planets */
  retrograde: {
    color: string;
    backgroundColor: string;
    borderColor?: string;
  };
}

/**
 * Default color scheme for Ashtamsha D8 table
 * All planets in black without background as requested
 */
export const DEFAULT_ASHTAMSHA_COLORS: AshtamshaPlanetColors = {
  regular: {
    color: 'black',
    backgroundColor: 'transparent'
  },
  lagna: {
    color: 'purple.600',
    backgroundColor: 'transparent'
  },
  hora: {
    color: 'orange.600',
    backgroundColor: 'transparent'
  },
  chandra: {
    color: 'cyan.600',
    backgroundColor: 'transparent'
  },
  retrograde: {
    color: 'black',
    backgroundColor: 'transparent',
    borderColor: 'gray.400'
  }
};

/**
 * Alternative color scheme - all black as requested
 */
export const BLACK_ONLY_ASHTAMSHA_COLORS: AshtamshaPlanetColors = {
  regular: {
    color: 'black',
    backgroundColor: 'transparent'
  },
  lagna: {
    color: '#e400fd',
    // backgroundColor: 'transparent'
    backgroundColor: 'rgb(255,255,255)'
  },
  hora: {
    color: '#0452fa',
    backgroundColor: 'transparent'
  },
  chandra: {
    color: '#13850f',
    backgroundColor: 'transparent'
  },
  retrograde: {
    color: 'black',
    backgroundColor: 'transparent'
  }
};

/**
 * Get color configuration for a planet type
 */
export function getAshtamshaPlanetColor(
  planetType: 'regular' | 'lagna' | 'hora' | 'chandra' | 'retrograde',
  colorScheme: AshtamshaPlanetColors = BLACK_ONLY_ASHTAMSHA_COLORS
) {
  return colorScheme[planetType];
}